import _classNames from 'clsx';
import * as React from 'react';
function HorizontalTable(_a) {
    var className = _a.className, items = _a.items;
    return (React.createElement("div", { className: _classNames('HorizontalTable', className) },
        React.createElement("table", { className: "HorizontalTable__table" },
            React.createElement("thead", null,
                React.createElement("tr", null, items === null || items === void 0 ? void 0 : items.map(function (item, index) { return (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement("th", { key: "".concat(item.label, "-").concat(index), className: "HorizontalTable__header" },
                    React.createElement("div", { className: "HorizontalTable__cell" }, item.label))); }))),
            React.createElement("tbody", null,
                React.createElement("tr", null, items === null || items === void 0 ? void 0 : items.map(function (item, index) { return (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement("td", { key: "".concat(item.value, "-").concat(index), className: "HorizontalTable__value" },
                    React.createElement("div", { className: "HorizontalTable__cell" }, item.value))); }))))));
}
export default HorizontalTable;
